import {
  Dropdown,
  Menu,
  Accordion,
  ScrollImageChanger,
  ScrollCurrentChecker,
  ScrollManager,
  ScrollTriggerClass,
  ScrollTextAnimation,
  AnchorScroll,
  InertialScroll,
  ShuffleText,
  ModalVideoPlayer,
} from './_main';

// home
import {
  OpeningAnimation,
  ScrollTitleAnimation,
  // NoteSlides,
  ScrollBackgroundGradient,
  ScrollImages,
  CountUp,
  ScrollTriggerBgClass,
  NoteApi,
  NewsApi,
  ScrollGetInTouch,
} from './_home'

// news
import {
  NewsArchiveApi,
  // NewsMore,
} from './_news'

{
  new InertialScroll();

  let domShuffleTextAry = [];
  const domShuffleText = document.querySelectorAll('[data-js="text-shuffle"]');
  if (domShuffleText) {
    [...domShuffleText].forEach(el => {
      domShuffleTextAry.push(new ShuffleText(el));
    });
    [...domShuffleTextAry].forEach((code, i) => {
      code.start(i);
    })
  }

  const domMenu = document.querySelector('[data-js="trigger"]');
  if (domMenu) new Menu(domMenu);

  const domScroller = document.querySelector('[data-scroller]');
  if (domScroller) new ScrollManager(domScroller);

  const domScrollTextAnimation = document.querySelectorAll('[data-js="scroll-text"]');
  if (domScrollTextAnimation) {
      [...domScrollTextAnimation].forEach(el=>{
          new ScrollTextAnimation(el);
      })
  }

  const domScrollTriggerClass = document.querySelectorAll('[data-js="stc"]');
  if (domScrollTriggerClass) new ScrollTriggerClass(domScrollTriggerClass);  

  const domModalVideoPlayer = document.querySelectorAll('[data-js="modal-video"]');
  if (domModalVideoPlayer) {
    [...domModalVideoPlayer].forEach(el => {
      new ModalVideoPlayer(el);
    })
  }
}

{  
  const domOpeningAnimation = document.querySelector('[data-js="visual"]');
  if (domOpeningAnimation) new OpeningAnimation(domOpeningAnimation);

  const domScrollTitleAnimation = document.querySelectorAll('[data-js="scroll-title"]');
  if (domScrollTitleAnimation) {
      [...domScrollTitleAnimation].forEach(el=>{
          new ScrollTitleAnimation(el);
      })
  }

  const domScrollGetInTouch = document.querySelector('[data-js="scroll-getintouch"]');
  if (domScrollGetInTouch) new ScrollGetInTouch(domScrollGetInTouch);

  const domCountUp = document.querySelector('[data-js="countup"]');
  if (domCountUp) new CountUp(domCountUp);

  const domScrollImages = document.querySelector('[data-js="images"]');
  if (domScrollImages) new ScrollImages(domScrollImages);

  // const domNoteSlides = document.querySelector('[data-js="note-slide"]');
  // if (domNoteSlides) new NoteSlides(domNoteSlides);
  const domNoteApi = document.querySelector('[data-js="note-slide"]');
  if (domNoteApi) new NoteApi(domNoteApi);
  
  const domNewsApi = document.querySelector('[data-js="news"]');
  if (domNewsApi) new NewsApi(domNewsApi);

  const domBackgroundGradient = document.querySelectorAll('[data-js="bg-gradient"]');
  if (domBackgroundGradient) {
    [...domBackgroundGradient].forEach(el=>{
      new ScrollBackgroundGradient(el);
    })
  }

  const domMoreButton = document.querySelectorAll('[data-js="stbgc"]');
  if (domMoreButton) new ScrollTriggerBgClass(domMoreButton);  
}

{
  const domNewsArchiveApi = document.querySelector('[data-js="news-archive"]');
  if (domNewsArchiveApi) new NewsArchiveApi(domNewsArchiveApi);

  // const domMoreButton = document.querySelector('[data-js="more"]');
  // if (domMoreButton) new NewsMore(domMoreButton);  
}